<template>
  <div>
    <main class="main-grid">
      <!-- Left Section: Form for Payment Info -->
      <div class="form-section">
        <section class="shop">
          <i class="fas fa-money-bill-wave"></i>
          <h1>Billing</h1>
        </section>

        <form class="contact-form" @submit.prevent="processPayment">
          <div v-if="this.formData.paymentMethod === 'PayPal'" class="form-group">
            <label for="paypalNote">Payment Description</label>
            <div class="note-display">{{ randomNote }}</div>
            <p class="payment-instructions">Send payment to: {{ paypalInfo }}</p>
          </div>

          <div v-if="this.formData.paymentMethod === 'Papara'" class="form-group">
            <label for="paypalNote">Payment Description</label>
            <div class="note-display">{{ randomNote }}</div>
            <p class="payment-instructions">Send payment to: 1231222139</p>
          </div>

          <div v-if="this.formData.paymentMethod === 'Crypto'" class="form-group">
            <label>Oxapay Payment Gateway</label>
            <p class="payment-instructions">You will be redirected to Oxapay to complete your payment.</p>
          </div>

          <button class="back-btn" type="button" @click="$emit('back')">Back</button>
          <button class="next-btn" type="submit">Complete Payment</button>
        </form>
      </div>

      <div class="order-summary">
        <h2>Order Summary</h2>
        <ul>
          <li v-for="(item, index) in cart" :key="index" class="order-item">
            <img :src="item.image" alt="Product Image" class="item-image" />
            <strong>{{ item.name }} x{{ item.quantity }} - ${{ (item.price * item.quantity).toFixed(2) }}</strong>
          </li>
        </ul>

        <div class="total-price">
          <strong>Total:</strong> ${{ finalPrice.toFixed(2) }}
        </div>

        <div v-if="formData" style="color: cornflowerblue;">
          <p><strong>Discount Code:</strong> {{ this.formData.discount }}</p>
          <p><strong>Payment Method:</strong> {{ this.formData.paymentMethod }}</p>
          <p><strong>Tip:</strong> {{ this.formData.tip ? "$"+this.formData.tip : 'No tip given' }}</p>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {db} from "@/firebase";
import {addDoc, collection, getDoc, doc} from "firebase/firestore";

export default {
  name: 'PaymentPage',
  props: {
    formData: Object
  },
  data() {
    return {
      discount: '',
      paymentMethod: '',
      paymentStatus: null,
      paypalInfo: 'https://www.paypal.com/paypalme/ShopT2b2t',
      randomNote: '',
      discountCodes: {
        'WELCOME20': 20,
        'SUMMER10': 10,
        'VIP50': 50
      },
      discountAmount: 0,
      tip: 0
    }
  },
  computed: {
    ...mapGetters(['cart']),

    totalPrice() {
      return this.cart.reduce((acc, item) => acc + (item.price * item.quantity), 0);
    },

    finalPrice() {
      const numericTip = parseFloat(this.formData.tip);
      return this.totalPrice + numericTip;
    }
  },
  async created() {
    this.generateRandomNote();
    await this.verifyCartItems();
  },
  methods: {
    generateRandomNote() {
      const words = ['apple', 'ocean', 'sunset', 'mountain', 'coffee', 'forest',
        'guitar', 'diamond', 'rocket', 'bubble', 'planet', 'window',
        'candle', 'river', 'desert', 'shadow', 'island', 'silence'];

      const shuffled = [...words].sort(() => 0.5 - Math.random());
      this.randomNote = shuffled.slice(0, 5).join(' ');
    },

    async verifyCartItems() {
      try {
        this.isLoading = true;
        const cartFromStore = this.cart;

        // Initialize verified cart
        this.cartItems = [];
        this.subtotal = 0;

        // Fetch current discount code info if provided
        if (this.formData.discount) {
          await this.verifyDiscountCode(this.formData.discount);
        }

        // Process tip
        if (this.formData.tip) {
          this.tipAmount = parseFloat(this.formData.tip) || 0;
        }

        for (const item of cartFromStore) {
          const kitRef = doc(db, 'kits', item.id);
          const kitDoc = await getDoc(kitRef);

          if (kitDoc.exists()) {
            const kitData = kitDoc.data();

            const verifiedItem = {
              id: item.id,
              name: kitData.name,
              price: kitData.price,
              image: kitData.image,
              quantity: item.quantity
            };

            this.cartItems.push(verifiedItem);
            this.subtotal += verifiedItem.price * verifiedItem.quantity;
          } else {
            console.error(`Item not found in database: ${item.id}`);
            this.$store.dispatch('removeItemFromCart', item.id);
          }
        }

      } catch (error) {
        console.error("Error verifying cart:", error);
      } finally {
        this.isLoading = false;
      }
    },

    async savePayment() {
      const paymentRef = collection(db, "payments")

      const docRef = await addDoc(paymentRef, {
        email: this.formData.email,
        discordName: this.formData.discord,
        coordinates: "Will be here soon...",
        description: this.randomNote,
        price: this.finalPrice.toFixed(2),
        discount: this.formData.discount,
        stage: "sent",
        tip: parseFloat(this.formData.tip),
        paymentMethod: this.formData.paymentMethod,
        kits: this.cart.flatMap(item => Array(item.quantity).fill(item.name)),
        timestamp: new Date()
      })

      return docRef.id;
    },
    async sendWebhook(){
      const webhookUrl = "https://discord.com/api/webhooks/1299782415644102696/bU4bRBobhecGh993AGaYIh1nn5o3mkiS1y6A-uDrxk03SsbvIhxte1sMETWc480m8WAR";
      const payload = {
        username: "Shop Notification",
        embeds: [
          {
            title: "Yeni Satın Alma!",
            color: 0x00ff00,
            fields: [
              { name: "E-posta", value: this.formData.email || "Bilinmiyor", inline: true },
              { name: "Ödeme Yöntemi", value: this.formData.paymentMethod, inline: true },
              { name: "Tutar", value: `$${this.finalPrice.toFixed(2)}`, inline: true },
            ],
            timestamp: new Date().toISOString(),
          }
        ]
      };

      try {
        await fetch(webhookUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
      } catch (err) {
        console.error("Discord webhook hatası:", err);
      }
    },
    async processPayment() {
      if (this.discount && this.discountCodes[this.discount]) {
        this.discountAmount = (this.totalPrice * this.discountCodes[this.discount]) / 100;
      }
      await this.sendWebhook();

      if (this.formData.paymentMethod === 'Crypto') {
        const orderId = await this.savePayment();

        this.paymentStatus = {
          type: 'processing',
          message: 'Redirecting to Oxapay gateway...'
        };

        const url = 'https://api.oxapay.com/v1/payment/invoice';

        const data = {
          amount: this.finalPrice.toFixed(2),
          currency: "USD",
          lifetime: 30,
          fee_paid_by_payer: 1,
          under_paid_coverage: 2.5,
          to_currency: "USDT",
          auto_withdrawal: false,
          mixed_payment: true,
          callback_url: "https://example.com/",
          return_url: "https://shopt2b2t.com/checkout/success/?orderid=" + orderId + "&method=" + this.formData.paymentMethod,
          email: this.formData.email,
          order_id: orderId,
          thanks_message: "Thanks for your purchase!",
          description: this.randomNote || "No description"
        };

        const headers = {
          'merchant_api_key': '5MPVC4-N43UBD-03TNDK-A7HY7D',
          'Content-Type': 'application/json',
        };

        try {
          const response = await fetch(url, {
            method: 'POST',
            headers,
            body: JSON.stringify(data),
          });

          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }

          const result = await response.json();

          if (result?.data.payment_url) {
            window.location.href = result.data.payment_url;
          }

        } catch (error) {
          console.error('Request failed:', error);
          alert("Failed to connect to payment gateway.");
        }
      }
      else if (this.formData.paymentMethod === 'PayPal') {
        const orderId = await this.savePayment();
        await this.$router.push("checkout/success/?orderid=" + orderId + "&method=" + this.formData.paymentMethod);
      }
      else if (this.formData.paymentMethod === 'Papara') {
        const orderId = await this.savePayment();
        await this.$router.push("checkout/success/?orderid=" + orderId + "&method=" + this.formData.paymentMethod);
      }
    },
    async fetchKits() {
      try {
        const kitsData = [];

        for (const item of this.cart) {
          const docRef = doc(db, 'kits', item.id);
          const docSnap = await getDoc(docRef);

          if (docSnap.exists()) {
            kitsData.push({
              id: docSnap.id,
              ...docSnap.data(),
              quantity: item.quantity
            });
          } else {
            console.warn(`Kit not found for ID: ${item.id}`);
          }
        }

        this.kits = kitsData;

      } catch (error) {
        console.error("Kits çekilemedi:", error);
      }
    }
  }
}
</script>

<style scoped>
main {
  display: flex;
  justify-content: space-between;
  gap: 2rem;
  padding: 2rem;
  color: #fff;
  flex-wrap: wrap;
}

.form-section,
.order-summary {
  display: flex;
  flex-direction: column;
}

.form-section {
  flex: 1;
  max-width: 500px;
  gap: 2rem;
}

.order-summary {
  flex: 1;
  background-color: #222;
  padding: 2rem;
  border-radius: 10px;
  border: 2px solid #444;
  width: 100%;
  max-width: 400px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
  margin-top: 2rem;
}

.order-summary h2 {
  font-size: 1.6rem;
  color: cornflowerblue;
  margin-bottom: 1rem;
}

.order-summary ul {
  list-style: none;
  padding: 0;
}

.order-summary li {
  margin-bottom: 0.7rem;
  font-size: 1.1rem;
  color: #ccc;
  display: flex;
  align-items: center;
}

.order-summary .item-image {
  width: 30px;
  height: 30px;
  margin-right: 10px;
  object-fit: cover;
}

.total-price {
  margin-top: 1rem;
  font-size: 1.3rem;
  font-weight: bold;
  color: cornflowerblue;
}

.shop {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  border-bottom: 5px solid cornflowerblue;
  margin-bottom: 1rem;
}

.shop i {
  margin-right: 1rem;
  font-size: 2rem;
  cursor: pointer;
}

.shop h1 {
  text-transform: uppercase;
  font-size: 2.2rem;
  font-weight: 500;
  letter-spacing: 1px;
}

.contact-form {
  background-color: #222;
  padding: 2rem;
  border-radius: 10px;
  border: 2px solid #444;
  width: 100%;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
}

.form-group {
  margin-bottom: 1.5rem;
  text-align: left;
}

label {
  display: block;
  margin-bottom: 0.5rem;
  font-size: 1.1rem;
  color: cornflowerblue;
}

input {
  width: 100%;
  padding: 0.7rem;
  border-radius: 6px;
  border: 1px solid #555;
  background-color: #111;
  color: #fff;
  font-size: 1rem;
}

select {
  width: 100%;
  padding: 0.5rem;
  font-size: 1rem;
  border-radius: 6px;
  border: 1px solid #444;
  background: #333;
  color: #fff;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  cursor: pointer;
}

select::-ms-expand {
  display: none;
}

select::after {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #fff;
  font-size: 1rem;
}

input, select {
  width: 100%;
  padding: 0.5rem;
  font-size: 1rem;
  border-radius: 6px;
  border: 1px solid #444;
  background: #333;
  color: #fff;
}

.next-btn {
  margin-top: 1rem;
  padding: 0.8rem 2rem;
  background-color: cornflowerblue;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.3s ease;
}

.next-btn:hover {
  background-color: royalblue;
}

.payment-instructions {
  background-color: #333;
  padding: 1rem;
  border-radius: 6px;
  border-left: 4px solid cornflowerblue;
  font-size: 0.9rem;
  color: #ddd;
}

.note-display {
  background-color: #111;
  padding: 0.7rem;
  border-radius: 6px;
  font-family: monospace;
  letter-spacing: 1px;
  color: #ffcc00;
  border: 1px solid #555;
  margin-bottom: 1rem;
}

.payment-status {
  margin-top: 1.5rem;
  padding: 1rem;
  border-radius: 6px;
  text-align: center;
}

.payment-status.success {
  background-color: rgba(39, 174, 96, 0.2);
  border: 1px solid #27ae60;
  color: #2ecc71;
}

.payment-status.pending {
  background-color: rgba(241, 196, 15, 0.2);
  border: 1px solid #f1c40f;
  color: #f1c40f;
}

.payment-status.processing {
  background-color: rgba(52, 152, 219, 0.2);
  border: 1px solid #3498db;
  color: #3498db;
}

.discount-applied {
  margin-top: 0.5rem;
  padding: 0.5rem;
  background-color: rgba(46, 204, 113, 0.1);
  border-radius: 4px;
  color: #2ecc71;
}

.back-btn {
  margin-right: 1rem;
  padding: 0.8rem 2rem;
  background-color: #555;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.3s ease;
}

.back-btn:hover {
  background-color: #777;
}
</style>